import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { fontSize, size } from '@twistopayments/design-system/styles'

export const card = css`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding: ${size[32]} ${size[16]};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 3px 12px rgba(130, 139, 153, 0.2);
`

export const logo = css`
  max-width: 190px;
  max-height: ${size[48]};

  img {
    width: 100%;
    height: 100%;
  }
`

export const content = css`
  margin-top: ${size[28]};
  display: flex;
  flex-direction: column;
  gap: ${size[8]};
`

export const badge = css`
  &::before {
    content: 'TOP';
    color: #2ecd5c;
    font-weight: 600;
    transform: rotate(45deg);
    position: absolute;
    z-index: 1;
    top: 0.6em;
    right: 0.6em;
  }

  &::after {
    content: '';
    position: absolute;
    text-align: center;
    top: -1em;
    right: -3em;
    background-color: #eafaee;
    width: 8em;
    height: 4em;
    transform: rotate(45deg);
  }
`

export const title = (theme: Theme) => css`
  color: ${theme.palette.primary.mainContrast};
  font-size: ${fontSize.xl};
  font-weight: 500;
`

export const secondary = css`
  font-size: ${fontSize.md};
  font-weight: 400;
`
